import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { updateCurrentUserLocale } from '../../ducks/user.duck';
import {
  localeFromPathname,
  resolveLocaleToPersist,
  setStoredLocale,
  shouldWriteProfileLocale,
} from '../../util/locale';

/**
 * Keep cookie + profile.privateData.locale in sync with the URL language.
 * Opening `/ar/l/...` is an explicit language choice; emails read privateData.locale.
 */
const LocalePreferenceSync = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(state => state.auth?.isAuthenticated);
  const currentUser = useSelector(state => state.user?.currentUser);
  const currentUserId = currentUser?.id?.uuid;
  const urlLocale = localeFromPathname(location.pathname);
  const profileLocale = currentUser?.attributes?.profile?.privateData?.locale;

  useEffect(() => {
    const next = resolveLocaleToPersist({
      urlLocale,
      profileLocale,
    });
    if (!next) {
      return;
    }
    if (urlLocale) {
      setStoredLocale(next);
    }
    if (
      isAuthenticated &&
      currentUserId &&
      shouldWriteProfileLocale({
        urlLocale,
        profileLocale,
      })
    ) {
      dispatch(updateCurrentUserLocale(next)).catch(() => {});
    }
  }, [urlLocale, profileLocale, isAuthenticated, currentUserId, dispatch]);

  return null;
};

export default LocalePreferenceSync;
